module.exports = __webpack_public_path__ + "img/3_atm_l1_l2_lr_l0.72fbe351.png";